import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';

// styles
import './style.scss';

// layout components
import Preloader from 'components/Preloader';

// assets
import { LoadingOutlined } from '@ant-design/icons';

// components
import SchoolAvatar from 'components/SchoolAvatar';

// utils
import { useMounted } from 'utils/hooks';
import _local from 'utils/localStorageUtils';


function SchoolPreview({
  view,
  loading,
  school,
  notifications,
  isActive,
  collapse,
  //actions
  onMount,
  onClick,
  // context
  user,
  // default props
  className,
  style,
  ...rest
}) {
  const mainClassNames = classNames('school-preview', 'school', className);

  const location = useLocation();
  const mounted = useMounted();

  const activeSchoolRef = useRef(null);

  const [loadNotif, setLoadNotif] = useState(false);
  const [currentBadge, setCurrentBadge] = useState(false);

  // Added force reference for active item, when component is mounted
  useEffect(() => {
    if (!!isActive && !!onMount) {
      onMount(activeSchoolRef);
    }
  }, [isActive]);

  useEffect(() => {
    if (!!school) {
      mountNotification(school?.key);
    }
  }, [notifications]);

  useEffect(() => {
    if (!!mounted && !!isActive) {
      mountNotification(school?.key);
    }
  }, [isActive, location.pathname]);

  const mountNotification = (schoolKey) => {
    const result = notifications?.find(el => el?.key == schoolKey);
    setCurrentBadge(result?.amount);
    !!result?.key && setLoadNotif(false);
  }

  const onClickHandler = () => {
    !!onClick && !loading && onClick(school);
  }

  return !!school && (
    <div 
      className={classNames(
        mainClassNames,
        loading && 'loading',
        collapse && 'collapse',
        isActive && "active"
      )}
      onClick={onClickHandler} 
      style={style}
      ref={isActive ? activeSchoolRef : null}
    >
      {loading && (
        <Preloader className="overlay-preloader" size="small" />
      )}
      {!!school && view == 'full' && (
        <div className="school-preview-wrapper">
          {!!currentBadge && (<span className="badge">{currentBadge}</span>)}
          {!!loadNotif && (<LoadingOutlined className="badge-preloader" />)}
          <SchoolAvatar fontSize={22} width={54} height={54} school={school} />
          <div className="school-preview__info">
            {school?.name && (
                <span className="info-name">
                  {school?.name}
                </span>
              )}
          </div>
        </div>
      )}
      
      {/* // compact view of student info (for header) */}
      {!!school && view == 'small' && (
        <>
          <div className="school-preview-small-wrapper">
            {!!currentBadge && (<span className="badge">{currentBadge}</span>)}
            {!!loadNotif && (<LoadingOutlined className="badge-preloader" />)}
            <SchoolAvatar view='small' fontSize={16} width={54} height={54} school={school} />
          </div>
        </>
      )}
    </div>
  );

}

SchoolPreview.defaultProps = {
  view: 'full',
  loading: false,
  collapse: false,
  isActive: false,
  notifications: []
};
SchoolPreview.propTypes = {
  view: PropTypes.oneOf(['full', 'small']).isRequired,
  school: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
    PropTypes.string,
  ]),
  onClick: PropTypes.func,
};

export default SchoolPreview;
